import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

const EventSearchForm = ({
  onSubmit,
  register,
  control,
  handleSubmit,
  isEventSearchLoading,
  skip,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <style>
        {`
        .home-date-input {
          color-scheme: light;
          position: relative;
        }
        .home-date-input::-webkit-calendar-picker-indicator {
          opacity: 0;
          width: 20px;
          height: 20px;
          cursor: pointer;
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translateY(-50%);
        }
        .home-date-input::-webkit-datetime-edit {
          color: white;
        }
        .home-date-input::-webkit-datetime-edit-text {
          color: white;
        }
        .home-date-input::-webkit-datetime-edit-month-field {
          color: white;
        }
        .home-date-input::-webkit-datetime-edit-day-field {
          color: white;
        }
        .home-date-input::-webkit-datetime-edit-year-field {
          color: white;
        }
        .home-date-input::-moz-calendar-picker-indicator {
          opacity: 0;
        }
        /* Custom calendar icon using calendar-modified.jpg */
        .date-input-wrapper::after {
          content: '';
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translateY(-50%);
          width: 20px;
          height: 20px;
          background-image: url('/images/calendar-modified.jpg');
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          pointer-events: none;
          z-index: 1;
          opacity: 1;
        }
        .date-input-wrapper {
          position: relative;
        }
      `}
      </style>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className={`flex w-full p-2 text-sm ${skip > 0
            ? "gap-2 md:gap-4 items-center flex-col sm:flex-row"
            : "flex-col gap-3"
            }`}
        >
          <div className={`flex flex-col ${skip > 0 ? "w-full sm:w-fit" : "w-full"}`}>
            {skip > 0 ? (
              <label className="mb-1 text-center sm:text-left">{t('home.search')}</label>
            ) : (
              <label className="mb-1 text-center">
                {t('home.searchSubtitle')}
              </label>
            )}
            <input
              type="text"
              {...register("eventSearch")}
              className="p-2 md:p-2 text-sm md:text-base border-2 sm:border bg-[#333] bg-opacity-50 border-[#555] rounded-md placeholder-[#aaa] text-white w-full"
            />
          </div>
          <div className={`flex gap-2 items-center ${skip > 0 ? "" : "flex-col"}`}>
            <div
              className={`flex w-full ${skip > 0
                ? "flex-row gap-2 md:gap-4"
                : "flex-row gap-3 sm:gap-5"
                }`}
            >
              <div className="flex flex-col w-fit">
                <label className="mb-1 text-center sm:text-left">{t('home.startDate')}</label>
                <div className="date-input-wrapper">
                  <Controller
                    name="startDate"
                    control={control}
                    render={({ field }) => (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={field.value || null}
                          onChange={(newValue) => field.onChange(newValue)}
                          format="DD/MM/YYYY"
                          slots={{
                            openPickerIcon: () => null,
                          }}
                          slotProps={{
                            textField: {
                              sx: {
                                input: { color: "white", padding: "10px 10px", },        // text color
                                label: { color: "white" },        // label color
                                svg: { color: "white" },          // icon color
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": { borderColor: "#555" },          // default border
                                  "&:hover fieldset": { borderColor: "white" },    // hover
                                  "&.Mui-focused fieldset": { borderColor: "white" } // focused
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    )}
                  />
                </div>
              </div>
              <div className="flex flex-col w-fit">
                <label className="mb-1 text-center sm:text-left">{t('home.endDate')}</label>
                <div className="date-input-wrapper">
                  <Controller
                    name="endDate"
                    control={control}
                    render={({ field }) => (
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={field.value || null}
                          onChange={(newValue) => field.onChange(newValue)}
                          format="DD/MM/YYYY"
                          slots={{
                            openPickerIcon: () => null,
                          }}
                          slotProps={{
                            textField: {
                              sx: {
                                input: {
                                  color: "white",
                                  padding: "10px 10px",
                                },
                                label: { color: "white" },        // label color
                                svg: { color: "white" },          // icon color
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": { borderColor: "#555" },          // default border
                                  "&:hover fieldset": { borderColor: "white" },    // hover
                                  "&.Mui-focused fieldset": { borderColor: "white" } // focused
                                },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    )}
                  />
                </div>
              </div>
            </div>
            <div className={`flex ${skip > 0 ? "w-fit" : "w-full"}`}>
              <button
                type="submit"
                disabled={isEventSearchLoading}
                className={`h-10 px-4 py-2 bg-red-700 text-white rounded hover:bg-red-800 disabled:opacity-50 transition-colors w-full ${skip > 0 ? "w-auto mt-6" : "mt-2 md:mt-5"
                  }`}
                style={{ fontSize: "14px", fontWeight: "normal" }}
              >
                <FontAwesomeIcon icon={faSearch} className={`${skip > 0 ? "block" : "hidden"} sm:hidden`} />
                <p className={`${skip > 0 ? "hidden" : "block"} sm:block`}>{t('home.search')}</p>
              </button>
            </div>
          </div>
        </div>
      </form>
    </>)
};

export default EventSearchForm;
